export default "__VITE_ASSET__CSvOIB7i__"